export default __webpack_public_path__ + "static/media/icon-gear-dark.64a64d79.svg";